const THEME_KEY = 'color_theme';
const ALLOWED_THEMES = ['light', 'dark', 'blue'];

const ColorThemesManager = {
  namespaced: true,

  state: {
    currentTheme: localStorage.getItem(THEME_KEY) || ALLOWED_THEMES[0],
  },

  actions: {
    initTheme({ commit }) {
      const savedTheme = localStorage.getItem(THEME_KEY);
      if (ALLOWED_THEMES.includes(savedTheme)) {
        commit('SET_THEME', savedTheme);
      } else {
        commit('SET_THEME', 'light');
        localStorage.setItem(THEME_KEY, 'light');
      }
    },

    setTheme({ commit }, theme) {
      if (ALLOWED_THEMES.includes(theme)) {
        localStorage.setItem(THEME_KEY, theme);
        commit('SET_THEME', theme);
      } else {
        console.warn(`Попытка установить недопустимую тему: ${theme}`);
      }
    },
  },

  mutations: {
    SET_THEME(state, theme) {
      state.currentTheme = theme;
      document.body.classList.remove(
        'body--light',
        'body--dark',
        'body--blue'
      );
      document.body.classList.add(`body--${theme}`);
      const themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (themeColorMeta) {
        switch (theme) {
          case 'dark':
            themeColorMeta.setAttribute('content', '#12181F');
            break;
          case 'blue':
            themeColorMeta.setAttribute('content', '#111827');
            break;
          case 'light':
          default:
            themeColorMeta.setAttribute('content', '#ffffff');
            break;
        }
      }
    }
  },

  getters: {
   
  },
};

export default ColorThemesManager;